<!--
 * @Author:
 * @Description: 附件列表
-->
<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="查看附件"
      v-if="dialogVisible"
      @close="closeDialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      width="1000px"
      v-dialogDrag
    >
      <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane
          v-for="(item, index) in attachmentListTabList"
          :key="index"
          :label="item.name"
          :name="item.id"
        ></el-tab-pane>
      </el-tabs>
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        class="mt-20px"
        height="480px"
        :highlight-current-row="true"
        ref="table"
        row-key="id"
        stripe
        border
      >
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column label="文件名称" prop="fileName" show-overflow-tooltip></el-table-column>
        <el-table-column label="文件类型" prop="fileType" show-overflow-tooltip></el-table-column>
        <el-table-column label="上传人" prop="createdUser" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="上传日期"
          prop="createdTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button size="mini" icon="el-icon-view" @click="toView(scope.row, 1)"></el-button>
            <el-button size="mini" icon="el-icon-delete" @click="toDelete(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="closeDialog">确定</el-button>
      </div>
    </el-dialog>
    <!-- 文件预览 -->
    <el-dialog
      v-if="centerDialogVisible"
      :title="`${previewFileName}`"
      top="4vh"
      width="70%"
      :visible.sync="centerDialogVisible"
      :modal-append-to-body="false"
      center
      v-dialogDrag
    >
      <img
        :src="previewVersionTag === 0 ? 'static/img/gz/在用.png' : 'static/img/gz/弃用.png'"
        alt
        v-if="versionManagement === 'true'"
        class="position-absolute"
        style="right: 10px; top: 65px"
      />
      <!-- 图片预览 -->
      <div
        id="splitImgDom"
        class="w-full h-740px flex justify-center"
        v-if="imgTypeList.includes(currentRow.fileType.toLowerCase())"
      >
        <img v-move :src="resourceUrl" id="splitImg" class="h-740px" />
      </div>
      <p
        v-if="currentRow.fileType === 'pdf'"
        class="height-20 text-14px has-text-right text-color-blue"
      >
        操作提示：Ctrl + 鼠标滚轮中键 可放大缩小
      </p>
      <iframe
        v-if="currentRow.fileType === 'wizdrawing' && showIframe"
        ref="htFrame"
        :src="htPage"
        width="100%"
        height="740px"
        class="myiframe"
        allowfullscreen
        @load="htLoad"
      ></iframe>
      <!-- pdf预览 -->
      <iframe
        v-else-if="showIframe && currentRow.fileType === 'pdf'"
        width="100%"
        height="740px"
        :src="`/lib/pdfjs/web/viewer.html?file=${resourceUrl}`"
        allowfullscreen
        allow="autoplay"
        class="myiframe"
      ></iframe>
      <div v-else-if="showIframe && currentRow.fileType === 'svg'">
        <div
          class="position-absolute modal--svg"
          v-loading="svgPreviewLoading"
          v-if="svgPreviewLoading"
        ></div>
        <iframe
          v-if="showSvgIFrame"
          class="w-full"
          @load="loadSvg"
          height="740px"
          :src="`/lib/svgView/index.html?file=${previewSvgUrl}?fileId=${previewSvgFileId}`"
        ></iframe>
      </div>
      <!-- 其他文件预览 -->
      <iframe
        :src="resourceUrl"
        width="100%"
        height="740px"
        v-else-if="
          showIframe &&
            !['svg', 'pdf'].includes(currentRow.fileType) &&
            !imgTypeList.includes(currentRow.fileType.toLowerCase())
        "
        allowfullscreen
        allow="autoplay"
        class="myiframe"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
import documentManagementService from '@/services/documentManagement'
import DocumentService from '@/services/DocumentService'

export default {
  name: 'attachmentList',
  props: {
    standardId: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    attachmentListTabList: {
      type: Array,
      default: () => {
        return []
      },
    },
    valueList: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      tabsList: [],
      activeName: '',
      tableLoading: false,
      tableData: [],
      activeTabData: {},
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
      centerDialogVisible: false,
      previewFileName: '',
      imgTypeList: ['bmp', 'jpg', 'jpeg', 'png', 'gif', 'webp'],
      currentRow: {},
      showIframe: false,
      resourceUrl: '',
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      previewSvgUrl: '',
      previewSvgFileId: '',
      svgPreviewLoading: false,
      showSvgIFrame: false,
    }
  },
  computed: {
    modelCenterVersion() {
      const version = _.find(this.systemParams, { parameterCode: 'modelCenterVersion' }) || {}
      return version.parameterValue
    },
    versionManagement() {
      const version = _.find(this.systemParams, { parameterCode: 'versionManagement' }) || {}
      return version.parameterValue
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val
      },
    },
    attachmentListTabList: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.activeName = val[0].id
          Object.keys(this.valueList).forEach((key) => {
            if (key.split('.').includes(val[0].columnName)) {
              this.activeTabData = this.valueList[key]
            }
          })
          this.getAttachmentList()
        }
      },
    },
    resourceUrl() {
      this.showIframe = false
      this.$nextTick(() => {
        this.showIframe = true
      })
    },
  },
  created() {},
  methods: {
    // 点击tab切换
    tabClick(tab) {
      Object.keys(this.valueList).forEach((key) => {
        if (key.split('.').includes(this.attachmentListTabList[tab.index].columnName)) {
          this.activeTabData = this.valueList[key]
        }
      })
      this.getAttachmentList()
    },
    // 获取列表数据
    async getAttachmentList() {
      const params =
        this.activeTabData?.map((item) => {
          return item.documentFileId
        }) || []
      this.tableLoading = true
      const res = await documentManagementService.documentUploadFiles(params)
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
      } else {
        this.tableData = []
      }
    },
    // 浏览文档
    async toView(row) {
      this.currentRow = row
      this.centerDialogVisible = true
      if (row.fileType === 'pr') {
        // 如果是pr模型就直接跳转新的浏览器页面查看
        window.open(`/#/docView?documentId=${row.id}`)
        return
      }
      if (row.fileType === 'wizdrawing') {
        const fileRes = await DocumentService.findFileUrl({
          id: row.id,
        })
        if (fileRes) {
          this.resourceUrl = fileRes
        }
      } else {
        this.resourceUrl = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${row.fileId}`
      }
      this.previewFileName = row.fileName
      this.previewVersionTag = row.versionTag
      if (row.fileType === 'svg') {
        this.svgPreviewLoading = true
        this.previewSvgUrl = this.resourceUrl
        this.showSvgIFrame = true
      }
    },
    // 删除附件
    toDelete(row) {
      this.$confirm('确认删除该附件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const params = [row.id]
          const res = await documentManagementService.deleteDocumentFiles(params)
          if (res && res.code === 0) {
            this.$message.success('删除成功')
            this.getAttachmentList()
          } else {
            this.$message.error('删除失败')
          }
        })
        .catch(() => {})
    },
    // 关闭弹框
    closeDialog() {
      this.dialogVisible = false
      this.$emit('closeAttachmentListDialog', false)
    },
    loadSvg() {
      // 加载完svg
      this.svgPreviewLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
